<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary">{{ 'COMPANIES.FILTER_CTA' | translate }}:</h3>
    <form
      [formGroup]="archived_companies_filters_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label> ID </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="business_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.VAT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="vat"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
